import { GuestForms } from '@/screens/ActivityPage/ui/Calendar/CalendarBody/GuestForms/GuestForms';
import { ReactElement, memo, ReactNode } from 'react';
import * as S from './TicketsCounter.style';
import { Button } from '../../buttons';

type TicketsDropdownProps = {
    selected?: number;
    lable?: ReactNode;
    needTicketsGuests?: boolean;
    ticketId?: number;
    errorMsg?: string | false;
    minCount?: number;
    maxCount?: number;
    onSelect: (item: number) => void;
    closeErrorMsg?: () => void;
    onTouch?: () => void;
};

const TicketsCounterContainer = ({
    selected,
    lable,
    needTicketsGuests,
    ticketId,
    errorMsg,
    closeErrorMsg,
    onSelect,
    onTouch,
    minCount,
    maxCount,
}: TicketsDropdownProps): ReactElement => {
    const count = selected ? +selected : 0;
    const isMax = !!selected && !!maxCount && maxCount <= selected;

    return (
        <S.CommonContainer>
            {lable}
            <S.Wrapper>
                <Button
                    onClick={() => {
                        if (!count) {
                            return;
                        }

                        onSelect(count - 1);
                    }}
                    variant="primary"
                    disabled={!count}
                    styles={`
                        max-width: 50px;
                        font-size: 32px !important;
                        padding-bottom: 16px !important;
                        flex-shrink: 0;
                    `}
                >
                    -
                </Button>
                <S.Counter>{count}</S.Counter>
                <Button
                    onClick={() => {
                        onTouch?.();

                        if (isMax) {
                            return;
                        }

                        onSelect(!selected ? minCount || 1 : selected + 1);
                    }}
                    variant="primary"
                    disabled={isMax}
                    styles={`
                        max-width: 50px;
                        font-size: 32px !important;
                        flex-shrink: 0;
                    `}
                >
                    +
                </Button>
            </S.Wrapper>
            {errorMsg && (
                <S.SelectTicketType onClick={() => closeErrorMsg?.()}>
                    <span>{errorMsg}</span>
                    <S.RedCrossIcon />
                </S.SelectTicketType>
            )}
            {needTicketsGuests && !!count && ticketId && (
                <GuestForms ticketId={ticketId} count={count} />
            )}
        </S.CommonContainer>
    );
};

export const TicketsCounter = memo(TicketsCounterContainer);
